const A4_PAPER_DIMENSIONS = {
  width: 210,
  height: 297,
};
const A4_PAPER_RATIO = A4_PAPER_DIMENSIONS.width / A4_PAPER_DIMENSIONS.height;

export { A4_PAPER_DIMENSIONS, A4_PAPER_RATIO };
